import { Box, Typography } from '@material-ui/core';

export default function FooterComponent() {
    return (
          <Box m={4}>
              <Typography variant="body1" align="center">
                © 2026 VIOSO GmbH<br />
		Version 1.6 (20260125)
              </Typography>
          </Box>
    )
}
